module.exports = __webpack_public_path__ + "img/lv.4fd871ca.svg";